<template>
  <div>
    <Header :coverPhoto="coverPhoto"></Header>
<!--    <div class="banner">-->
<!--      <img src="@/assets/images/banner3.png" alt="">-->
<!--    </div>-->
    <div class="recruit">
      <div class="title">
        <h3>职位招聘 / Job recruitment</h3>
        <p>如您感兴趣请与我们联系</p>
      </div>
      <div class="recruit-container">
        <ul>
          <li :title="news.newsContentTitle" v-for="(news, idx) in recruitList" :key="idx" @click="goDetail(news.newsContentLink, news.templateRecordUrl, news.newsContentType, news.newsContentContent)">
            <div class="position-name">
              <span>{{ news.newsContentTitle }}</span>
            </div>
            <div class="position-intro">
              <h4>职位介绍</h4>
              <div class="position-intro-text">
                <p>{{news.newsContentSummary}}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="pager" v-if="page.totalPage > 1">
        <span @click="paging(1)">首页</span>
        <span @click="paging(page.page - 1)" v-if="page.page > 1">上一页</span>
        <ul v-if="page.totalPage > 0 && page.totalPage <= 5">
          <li v-for="cpage in page.totalPage" :class="{'active': page.page == cpage}" :key="cpage" @click="paging(cpage)">
            {{cpage}}
          </li>
        </ul>
        <ul v-if="page.totalPage > 5">
          <li v-if="page.page < 3" v-for="cpage in 5" :class="{'active': page.page == cpage}" :key="cpage" @click="paging(cpage)">
            {{cpage}}
          </li>
          <li v-if="page.page > page.totalPage - 2" v-for="cpage in 5" :class="{'active': page.page == (page.totalPage - 5 + cpage)}" :key="cpage" @click="paging(page.totalPage - 5 + cpage)">
            {{page.totalPage - 5 + cpage}}
          </li>
          <li v-if="page.page >= 3 && page.page <= page.totalPage - 2" v-for="cpage in 5" :class="{'active': page.page == (page.page - (3 - cpage))}" :key="cpage" @click="paging(page.page - (3 - cpage))">
            {{page.page - (3 - cpage)}}
          </li>
        </ul>
        <span @click="paging(page.page + 1)" v-if="page.page < page.totalPage">下一页</span>
        <span @click="paging(page.totalPage)">尾页</span>
      </div>
    </div>
    <div class="loading" v-if="isLoading">
      <img src="@/assets/images/loading.gif" alt="">
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/assets/components/Header'
import Footer from '@/assets/components/Footer'
import url from '@/assets/public/url'
import axios from 'axios'
export default {
  name: "Recruit",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      page: {
        page: 1,
        rows: 9,
        totalPage: 1,
        newsDirectoriesId: 'dffd3376-9f78-44bb-afa5-4b41b1b8a4c5'
      },
      requestUrl: url.url,
      recruitList: [],
      isLoading: false,
      coverPhoto: ''
    }
  },
  methods: {
    goDetail: function (link, url, type, outlink) {
      if (type === '6') {
        window.open(outlink)
      } else {
        window.location.href = this.requestUrl + '/' +url
      }
    },
    getRecruitList: function () {
      var self = this
      self.isLoading = true
      axios.get(self.requestUrl + '/news/app/newscontent/listpagenewscontentrelease', {
        params: self.page
      }).then(function (res) {
        self.recruitList = res.data.rows
        self.page.page = res.data.page
        self.page.totalPage = Math.ceil(res.data.total / self.page.rows)
        self.isLoading = false
      })
    },
    paging: function (page) {
      this.page.page = page
      this.getRecruitList()
    },
    // 获取版块介绍
    getBoxIntro: function () {
      var self = this
      axios.get(self.requestUrl + '/news/app/newsdirectories/getnewsdirectoriesbyidrelease/dffd3376-9f78-44bb-afa5-4b41b1b8a4c5').then(function (res) {
        self.coverPhoto = res.data.directoriesPhoto
      })
    },
  },
  mounted() {
    this.getRecruitList()
    this.getBoxIntro()
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import "~styles/public.styl"
.banner, .banner img
  width 100%
  height 400px
.recruit
  width 1200px
  margin 35px auto
  .title
    text-align center
    padding 25px 0
    border-bottom 1px solid $main-blue
    margin-bottom 50px
    h3
      font-size 28px
      color #666
      font-weight normal
      margin-bottom 15px
    p
      font-size 14px
      color #999
  .recruit-container
    ul
      min-height 500px
      &:after
        content ''
        display block
        clear both
      li
        float left
        width 330px
        margin-right 45px
        margin-bottom 40px
        border-radius 5px
        box-shadow 0 0 10px #aaa
        padding 0 20px 20px
        cursor pointer
        &:nth-child(3n)
          margin-right 0
        .position-name
          padding 20px 0
          text-align center
          border-bottom 1px dashed #eee
          margin-bottom 25px
          span
            font-weight bold
            font-size 20px
            color #333
            display inline-block
            padding-left 30px
            background url("~@/assets/images/recruit-icon.png") no-repeat left center
        .position-intro
          padding 0 10px
          h4
            font-size 16px
            color $main-blue
            margin-bottom 20px
          .position-intro-text
            height 240px
            overflow hidden
            p
              font-size 14px
              color #333
              line-height 30px
.pager
  text-align center
  font-size 0
  margin-bottom 20px
  span
    display inline-block
    padding 0 15px
    line-height 30px
    color #333
    font-size 14px
    margin 0 5px
    vertical-align middle
    cursor pointer
    border 1px solid #CCCCCC
  ul
    display inline-block
    overflow hidden
    vertical-align middle
    li
      width 30px
      line-height 30px
      float left
      margin-right 10px
      cursor pointer
      text-align center
      font-size 14px
      color #333
      border 1px solid #CCCCCC
      &.active
        color: $main-blue
        border 1px solid $main-blue
        box-sizing border-box
      &:last-child
        margin 0
</style>



// WEBPACK FOOTER //
// src/pages/Recruit/Recruit.vue